/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { LockOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { paragraphMedium } from 'src/components/css'

type InviteApprovalLockProps = {
  /** Why nobody can be invited from here yet: approval, or the budget's lock. */
  reason: string
  testId?: string
}

/**
 * Jeff, Oct 1 — where invites can't be sent yet, the panel says why instead of
 * the option going missing: a lock and the reason, centred. Add Player Slots ›
 * Reserved Player Slots before the team registration is approved, and Import
 * Players From Previous Seasons on a sheet that can't import.
 */
const InviteApprovalLock = ({
  reason,
  testId = 'add-slot-invite-blocked',
}: InviteApprovalLockProps) => (
  <div css={blockedStyle} data-testid={testId}>
    <LockOutlined css={blockedIconStyle} />
    <p css={blockedTextStyle}>{reason}</p>
  </div>
)

export default InviteApprovalLock

const blockedStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 0 8px;
  text-align: center;
`
const blockedIconStyle = css`
  font-size: 24px;
  color: ${colors.NEUTRAL_70};
`
const blockedTextStyle = css`
  ${paragraphMedium};
  margin: 0;
  max-width: 380px;
  color: ${colors.NEUTRAL_50};
  line-height: 1.5;
`
